export default "__VITE_ASSET__efd09c71__"